import React from 'react';
import { SvgIcon } from '@mui/material';

export function Communication({ isSm }) {
  return isSm ? (
    <SvgIcon sx={{ width: 25, height: 25 }} viewBox="0 0 25 25">
      <rect x="0.574219" y="0.5" width="24" height="24" rx="8" fill="#4520AB" />
      <ellipse
        cx="10.7234"
        cy="10.9537"
        rx="3.88356"
        ry="3.86381"
        stroke="white"
        strokeWidth="1.2"
        fill="#4520AB"
      />
      <path
        d="M15.3121 17.9081C14.7094 17.1731 13.9939 16.5901 13.2064 16.1923C12.4189 15.7946 11.5748 15.5898 10.7225 15.5898C9.87009 15.5898 9.02606 15.7946 8.23856 16.1923C7.45107 16.5901 6.73553 17.1731 6.13281 17.9081"
        stroke="white"
        strokeWidth="1.2"
        fill="#4520AB"
      />
      <path
        d="M17.4306 13.272C17.6545 13.0183 17.8321 12.7171 17.9532 12.3856C18.0744 12.0542 18.1367 11.6989 18.1367 11.3401C18.1367 10.9813 18.0744 10.626 17.9532 10.2946C17.8321 9.96309 17.6545 9.6619 17.4306 9.4082"
        stroke="white"
        strokeWidth="1.2"
        fill="#4520AB"
      />
      <path
        d="M20.2548 14.8181C20.4787 14.3615 20.6563 13.8193 20.7774 13.2227C20.8986 12.626 20.9609 11.9865 20.9609 11.3407C20.9609 10.6949 20.8986 10.0554 20.7774 9.45874C20.6563 8.86208 20.4787 8.31994 20.2548 7.86328"
        stroke="white"
        strokeWidth="1.2"
      />
    </SvgIcon>
  ) : (
    <SvgIcon sx={{ width: 57, height: 57 }} viewBox="0 0 57 57">
      <g clipPath="url(#clip0_11963_195188)">
        <rect
          x="0.667969"
          y="0.84375"
          width="56"
          height="56"
          rx="20"
          fill="#4520AB"
        />
        <ellipse
          cx="22.79"
          cy="25.6239"
          rx="8.08691"
          ry="8.04579"
          stroke="white"
          strokeWidth="2.49881"
          fill="#4520AB"
        />
        <path
          d="M32.3411 40.1068C31.086 38.5763 29.596 37.3622 27.9562 36.5339C26.3163 35.7056 24.5588 35.2793 22.7838 35.2793C21.0089 35.2793 19.2513 35.7056 17.6115 36.5339C15.9716 37.3622 14.4816 38.5763 13.2266 40.1068"
          stroke="white"
          strokeWidth="2.49881"
          fill="#4520AB"
        />
        <path
          d="M36.7484 30.452C37.2146 29.9237 37.5843 29.2966 37.8366 28.6063C38.0889 27.9161 38.2187 27.1763 38.2187 26.4291C38.2187 25.682 38.0889 24.9422 37.8366 24.252C37.5843 23.5617 37.2146 22.9345 36.7484 22.4062"
          stroke="white"
          strokeWidth="2.49881"
        />
        <path
          d="M42.6351 33.6719C43.1013 32.7209 43.4711 31.592 43.7233 30.3496C43.9756 29.1071 44.1055 27.7755 44.1055 26.4307C44.1055 25.0858 43.9756 23.7542 43.7233 22.5117C43.4711 21.2693 43.1013 20.1404 42.6351 19.1895"
          stroke="white"
          strokeWidth="2.49881"
        />
      </g>
      <defs>
        <clipPath id="clip0_11963_195188">
          <rect
            width="56"
            height="56"
            fill="white"
            transform="translate(0.667969 0.84375)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
